import { gql } from "~/__generated__"

export const PASSWORD_RESET_SEND_EMAIL_MUTATION = gql(`
  mutation PasswordResetSendEmail($input: PasswordResetSendEmailInput!) {
    passwordResetSendEmail(input: $input) {
      success
    }
  }
`)
